import React from 'react';
import { Box, Typography, Tooltip } from '@mui/material';

const VersionSignature: React.FC = () => {
  // Show version in all environments
  // Can be disabled by setting REACT_APP_HIDE_VERSION=true
  if (process.env.REACT_APP_HIDE_VERSION === 'true') {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 0,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 9999,
        opacity: 0.3,
        transition: 'opacity 0.3s ease',
        '&:hover': {
          opacity: 1,
        }
      }}
    >
      <Tooltip title={`v${process.env.REACT_APP_VERSION || '1.0.0'}`} placement="top" arrow>
        <Typography
          variant="caption"
          sx={{
            fontSize: '0.6rem',
            color: 'text.secondary',
            fontFamily: 'monospace',
            backgroundColor: 'rgba(0, 0, 0, 0.05)',
            padding: '1px 4px',
            borderRadius: '4px',
            border: '1px solid rgba(0, 0, 0, 0.1)',
            userSelect: 'none',
            cursor: 'default',
          }}
        >
          v{process.env.REACT_APP_VERSION || '1.0.0'}
        </Typography>
      </Tooltip>
    </Box>
  );
};

export default VersionSignature;
